import { useRef, useState, useEffect } from 'react';
import GridControl from "../../../Controls/GridControl"
import ShowOwnerResidentialInfo from "../../../Controls/ShowOwnerResidentialInfo"
import SelectControl from "../../../Controls/SelectControl"
import { useNavigate } from "react-router-dom";

import {
    BrowserRouter,
    Route,
    Routes
} from "react-router-dom";

import { 
	GetLocal,
	SetLocal,
	FetchService,
	GetParamsUrl
} from "../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

export default function Index(props) {
	const navigate = useNavigate();
	
    const inputRef = useRef(null);
	const [getServiceResult, setServiceResult] = useState(false);
	const [getSelectData, setSelectData] = useState([]);

    useEffect(() => {
		
		var inputValue = {};
		FetchService("General/Abstract/ShowFilesReviewAbstractList", inputValue, ShowFilesReviewAbstractListSuccess);

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			fileNumber: GetLocal('FileNumber')
		};	
		EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowFileReviews", inputValue, ShowFileReviewsSuccess);	
    }, []);	
	
	const ShowFilesReviewAbstractListSuccess =(ServiceResult)=>{
		setSelectData(ServiceResult.ReviewInfo)			
	}	

	const ShowFileReviewsSuccess =(ServiceResult)=>{
		setServiceResult(ServiceResult.RequestsReviewList)			
	}	
	
	const DataGrid =()=>{
		return (
			<GridControl
				data={getServiceResult}
				customHeaders={{"RequestNumber": "شماره درخواست","RequestDate": "تاریخ","RequestTitle": "نوع","ComboBox":"عملیات"}}		
				ComboBox={ComboBox} 
			/>
		)		
	}

	const ComboBox =(value,i)=>{		
		
		return (
			<SelectControl
				data={getSelectData}
				onChange={OnchangeSelectControl.bind(i,value)}			
			/>	
		)			
		
	}	
	
	const OnchangeSelectControl =(value,i)=>{
		if(i == '')
			return;
		
		SetLocal('RequestNumber',Number(value.RequestNumber)); 
		
		switch(Number(i)) {	
		  case 1:
			navigate("/Employee/Requests/FilingReview?page=تشکیل پرونده");
			break;	
		  case 2:
			navigate("/Employee/Requests/OwnerReview?page=مالکین");
			break;	
		  case 3:
			navigate("/Employee/Requests/ReviewApplication?page=درخواست");
			break;	
		  case 4:
			navigate("/Employee/Requests/ReviewVisitReports?page=گزارش بازدید");
			break;	
		  case 5:
			navigate("/Employee/Requests/ProceedingsReview?page=اقدامات");
			break;	
		  case 6:
			navigate("/Employee/Requests/ReviewDocuments?page=مدارک");
			break;	
		  case 7:
			navigate("/Employee/Requests/ReviewCorrespondence?page=نامه نگاری");
			break;	
		  case 8:
			navigate("/Employee/Requests/DesignReview?page=طرح بر و کف");
			break;	
		  case 9:
			navigate("/Employee/Requests/OrdersReviewMap?page=نقشه");
			break;	
		  case 10:
			navigate("/Employee/Requests/ComplicationsReview?page=پروانه");
			break;	
		  case 11:
			navigate("/Employee/Requests/CertificateEffects?page=گواهی");
			break;	
		  case 12:
			navigate("/Employee/Requests/OffencerView?page=خلاف");
			break;		
		  case 13:
			navigate("/Employee/Requests/ReviewDraftPermit?page=پیش نویس پروانه");
			break;	
		  case 14:
			navigate("/Employee/Requests/DraftReview?page=پیش نویس گواهی");
			break;	
		  case 15:
			navigate("/Employee/Requests/FinancialStatus?page=وضعیت نوسازی");
			break;			
		}
	}		

    return (
		<div class="text-center my-4">
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<DataGrid/>
		</div>
    );
}
